// extracted by mini-css-extract-plugin
module.exports = {"container":"featureCard_container__KLnAc","title":"featureCard_title__XA_3i","description":"featureCard_description__SNF_H","url":"featureCard_url__VTWE_"};